module.exports = __webpack_public_path__ + "img/search-yellow.3f54199e.svg";